// extracted by mini-css-extract-plugin
export var legendIndicator = "_e7-1";
export var legendRight = "_e7-0";